import * as React from 'react'
import withHydrationOnDemand from 'react-hydration-on-demand'

import {
  useExperiments,
  useRequestConfig,
  useSiteConfig,
} from '@thg-commerce/enterprise-core'
import { useTheme } from '@thg-commerce/enterprise-pages/src/Product/theme'
import { SwatchShape } from '@thg-commerce/gravity-elements/Swatch/types'

import { useProductPage } from '../../context'
import { ProductOptionSelectorRenderer } from '../../renderers'
import { ProductOptionKeys } from '../ProductReviews/PaginatedProductReviews/OtherCustomersBought/OtherCustomersBought'
import { SizeGuideContainer } from '../'

const ProductOptionSelectorRendererComponent = withHydrationOnDemand({
  on: [['idle']],
})(ProductOptionSelectorRenderer)

const shouldRenderMobilePDPStickyAddToBasket = (
  enableMobilePDPStickyAddToBasket?: boolean,
  stickyAddToBagExperiment?: string,
) => {
  return (
    enableMobilePDPStickyAddToBasket ||
    stickyAddToBagExperiment === 'v1|show_sticky_add_cta'
  )
}

export const ProductOptions = () => {
  const theme = useTheme()
  const {
    product,
    selectedVariant,
    setSelectedVariant,
    selectedOptions,
    setSelectedOptions,
    defaultVariant,
    activeTabIndex,
    setActiveTabIndex,
    storeStockActive,
    setStoreStockActive,
    optionsMap,
    setOptionsMap,
  } = useProductPage()
  const { isMobileApp } = useRequestConfig()
  const {
    enablePushNotifyWhenInStock,
    productPageOptionKeysWithAttribute,
    enableMobilePDPStickyAddToBasket,
    enablePriceOnMobilePDPStickyAddToBasket,
    enableProductPersonalisation,
    disableColorDropdown,
    enableSubscribeAndSaveInlinePricing,
  } = useSiteConfig()

  const experiments = useExperiments()

  const displaySizeGuideContainer = productPageOptionKeysWithAttribute?.includes(
    ProductOptionKeys.SIZE,
  )
  const variantChangedCallback = (variant) => {
    setSelectedVariant && setSelectedVariant(variant)
  }

  const setSelectedOptionsCallback = (selectedOptions) => {
    setSelectedOptions && setSelectedOptions(selectedOptions)
  }

  return (
    <ProductOptionSelectorRendererComponent
      product={product}
      masterProductSku={product?.sku}
      initialSelectedOptions={product?.selectedOptions}
      sortedOptionKeys={product?.sortedOptionKeys}
      forceDropDowns={false}
      swatchShape={SwatchShape.CIRCLE}
      showSwatches={true}
      notifyWhenInStock={product?.hasVariantsWithNotifyWhenInStockEnabled}
      labelCustomComponent={
        displaySizeGuideContainer && (
          <SizeGuideContainer sizeGuide={product?.sizeGuide} />
        )
      }
      isFirstProductRecommendation={false}
      variantChangedCallback={variantChangedCallback}
      selectedOptions={selectedOptions}
      setSelectedOptionsCallback={setSelectedOptionsCallback}
      selectedVariant={selectedVariant}
      defaultVariant={defaultVariant}
      variants={product?.variants || []}
      wrapperProps={
        (isMobileApp &&
          enablePushNotifyWhenInStock &&
          selectedVariant?.notifyWhenInStockEnabled) ||
        theme?.pageTheme?.productOptions?.addToBasketContainer?.fullWidth ||
        enableProductPersonalisation
          ? { style: { width: '100%' } }
          : undefined
      }
      enableMobilePDPStickyAddToBasket={shouldRenderMobilePDPStickyAddToBasket(
        enableMobilePDPStickyAddToBasket,
        experiments['mobile_sticky_add_cta'],
      )}
      enablePriceOnMobilePDPStickyAddToBasket={
        enablePriceOnMobilePDPStickyAddToBasket
      }
      defaultProductOptions={product?.defaultProductOptions}
      queryFullVariantData={true}
      disableColorDropdown={disableColorDropdown}
      enableSubscribeAndSaveInlinePricing={enableSubscribeAndSaveInlinePricing}
      activeTabIndex={activeTabIndex}
      setActiveTabIndex={setActiveTabIndex}
      storeStockActive={storeStockActive}
      setStoreStockActive={setStoreStockActive}
      optionsMap={optionsMap}
      setOptionsMap={setOptionsMap}
    />
  )
}
